<div class="auth-container">
  <div class="auth-background">
    <div class="background-pattern"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <div *ngIf="isWebPlatform" class="app-download-section">
        <p class="download-text">Download the app</p>
        <div class="download-badges">
          <a
            href="https://apps.apple.com/app/id6755013572"
            target="_blank"
            rel="noopener noreferrer"
            class="badge-link app-store-badge"
            aria-label="Download on the App Store"
          >
            <img
              src="assets/DownloadAppStore.svg"
              alt="Download on the App Store"
              class="store-badge"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=rs.padelpoint.app"
            target="_blank"
            rel="noopener noreferrer"
            class="badge-link google-play-badge"
            aria-label="Get it on Google Play"
          >
            <img
              src="assets/GetItOnGooglePlay.svg"
              alt="Get it on Google Play"
              class="store-badge"
            />
          </a>
        </div>
      </div>
      <div class="auth-header">
        <div class="app-logo">
          <img
            class="logo-img"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="app-title">ReBall</h1>
        </div>
        <h2 class="auth-title">Welcome Back</h2>
        <p class="auth-subtitle">Sign in to your account to continue</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label class="form-label" for="username">Username</label>
          <div class="input-wrapper">
            <input
              type="text"
              id="username"
              formControlName="username"
              class="form-input"
              [class.error]="submitted && f?.['username']?.errors"
              placeholder="Enter your username"
            />
            <div class="input-icon">
              <lucide-icon name="user" [size]="18"></lucide-icon>
            </div>
          </div>
          <div
            *ngIf="submitted && f?.['username']?.errors"
            class="error-message"
          >
            <div *ngIf="f?.['username']?.errors?.['required']">
              Username is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="password-header">
            <label class="form-label" for="password">Password</label>
            <a routerLink="/forgot-password" class="forgot-password-link"
              >Forgot Password?</a
            >
          </div>
          <div class="input-wrapper">
            <input
              type="password"
              id="password"
              formControlName="password"
              class="form-input"
              [class.error]="submitted && f?.['password']?.errors"
              placeholder="Enter your password"
            />
            <div class="input-icon">
              <lucide-icon name="lock" [size]="18"></lucide-icon>
            </div>
          </div>
          <div
            *ngIf="submitted && f?.['password']?.errors"
            class="error-message"
          >
            <div *ngIf="f?.['password']?.errors?.['required']">
              Password is required
            </div>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="loading"
          class="auth-button primary"
          [class.loading]="loading"
        >
          <div class="button-content">
            <div class="button-spinner" *ngIf="loading"></div>
            <span class="button-text">{{
              loading ? "Signing In..." : "Sign In"
            }}</span>
          </div>
        </button>

        <div class="auth-divider">
          <span>Don't have an account?</span>
        </div>

        <button
          type="button"
          routerLink="/register"
          class="auth-button secondary"
        >
          Create Account
        </button>

        <div *ngIf="error" class="error-alert">
          <div class="error-icon">
            <lucide-icon name="alert-triangle" [size]="18"></lucide-icon>
          </div>
          <span>{{ error }}</span>
        </div>
      </form>
    </div>
  </div>
</div>
